import { useDispatch } from 'react-redux'
import { AggregateValue } from 'ui-components'
import {
  setAggregateProperty,
  useAggregateProperty
} from '~map-preview/states/boundaries'
import { useNumericProperties } from '~map-preview/states/map'

function BoundaryAggregateInput() {
  const dispatch = useDispatch()
  const numericProperties = useNumericProperties()
  const aggregatedValue = useAggregateProperty()

  const handleChange = (event, value) => {
    dispatch(setAggregateProperty(value))
  }

  const properties = [
    { label: 'Location count', name: 'count' } as any,
    ...numericProperties
  ]

  return (
    <AggregateValue
      value={aggregatedValue}
      properties={properties}
      onChange={handleChange}
    />
  )
}

export { BoundaryAggregateInput }
